const isCollapsed = ref(false)

export default () => isCollapsed
